export default __webpack_public_path__ + "static/media/keto-bars@3x.cbfb63a5.png";